import { useContext } from 'react';
import { GiveNowContext } from '../GiveNowContext';

export const useGiveNow = () => {
  const context = useContext(GiveNowContext);
  if (!context) {
    throw new Error('useGiveNow must be used within a GiveNowProvider');
  }

  return context;
};
